<div class="sick-leave-container">
    <!-- DATEV Authentication Required Message -->
    <div class="auth-required-message" *ngIf="!datevAuthService.getAuthStatus()()">
        <div class="warning-icon">⚠️</div>
        <h3>DATEV Authentifizierung erforderlich</h3>
        <p>Um Krankmeldungen zu erstellen, müssen Sie sich zuerst bei DATEV anmelden.</p>
        <button class="datev-login-button" (click)="loginDatev()">
            Bei DATEV anmelden
        </button>
    </div>

    <!-- Sick Leave Form (only shown when authenticated) -->
    <div *ngIf="datevAuthService.getAuthStatus()()">
    <h2>Krankmeldung erfassen</h2>
    <form [formGroup]="sickLeaveForm" (ngSubmit)="onSubmit()" >
        <div class="form-field">
            <label for="employeeId">Mitarbeiter *</label>
            <select
                    id="employeeId"
                    formControlName="employeeId"
                    [class.ng-invalid]="sickLeaveForm.get('employeeId')?.invalid && sickLeaveForm.get('employeeId')?.touched"
            >
                <option value="">Bitte wählen</option>
                <option *ngFor="let employee of employeeSignal()" [value]="employee.datevEmployeeNumber">
                    {{ employee.name }} ({{ employee.datevEmployeeNumber }})
                </option>
            </select>
            <div class="error-message"
                 *ngIf="sickLeaveForm.get('employeeId')?.invalid && sickLeaveForm.get('employeeId')?.touched">
                Bitte wählen Sie einen Mitarbeiter aus.
            </div>
        </div>

        <div class="form-field">
            <label for="startDate">Beginn der Krankmeldung *</label>
            <input
                    id="startDate"
                    type="date"
                    formControlName="startDate"
                    [class.ng-invalid]="sickLeaveForm.get('startDate')?.invalid && sickLeaveForm.get('startDate')?.touched"
            >
            <div class="error-message"
                 *ngIf="sickLeaveForm.get('startDate')?.invalid && sickLeaveForm.get('startDate')?.touched">
                Bitte geben Sie ein Datum ein.
            </div>
        </div>

        <div class="form-field">
            <label for="endDate">Ende der Krankmeldung *</label>
            <input
                    id="endDate"
                    type="date"
                    formControlName="endDate"
                    [class.ng-invalid]="sickLeaveForm.get('endDate')?.invalid && sickLeaveForm.get('endDate')?.touched"
            >
            <div class="error-message"
                 *ngIf="sickLeaveForm.get('endDate')?.hasError('required') && sickLeaveForm.get('endDate')?.touched">
                Bitte geben Sie ein Enddatum ein.
            </div>
            <div class="error-message"
                 *ngIf="sickLeaveForm.get('endDate')?.hasError('invalidEndDate') && sickLeaveForm.get('endDate')?.touched">
                Das Enddatum muss nach dem Startdatum liegen.
            </div>
        </div>

        <div class="form-field checkbox-field">
            <label>
                <input
                        type="checkbox"
                        formControlName="isFollowUp"
                >
                Folgekrankmeldung
            </label>
        </div>

        <div class="form-field checkbox-field">
            <label>
                <input
                        type="checkbox"
                        formControlName="mitAttest"
                >
                Mit Attest
            </label>
        </div>

        <div class="button-group">
            <button type="submit" [disabled]="sickLeaveForm.invalid">
                Weiter
            </button>
        </div>
    </form>
    </div>
    <!--app-sick-leave-confirmation *ngIf="!displayFormHideConfirmation()"/-->
</div>